import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'provide_approximate_workers_who_can_communicate_primary_language'

export const dataPointDefinition = {
  retracedId: 'provide_approximate_workers_who_can_communicate_primary_language',
  name: 'Please provide approximate % of workers who can communicate in the primary language spoken at the facility:',
  description:
    'This should be the approximate % of workers who can speak and understand this language. They may speak other languages as well.',
  meta: {
    slcpMeta: {
      key: 'fp-nl-13',
      number: 'FP-LAN-3',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-nl-13', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27850,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
